<template>
  <v-container>
    <v-layout column class="mb-12">
      <v-layout justify-center>
        <Logo></Logo>
      </v-layout>
      <v-layout column>
        <v-container grid-list-xl>
          <v-layout row wrap justify-center>
            <v-flex xs12 sm4>
              <v-select
                  v-model="selectedSpecies"
                  :items="species"
                  item-text="name"
                  item-value="id"
                  label="Species"
                  outlined
                  hint="Choose a species"
                  persistent-hint
                  @change="speciesHandler"
              ></v-select>
            </v-flex>
            <v-flex xs12 sm4 v-if="sequence">
              <v-textarea
                  v-model="selectedSequence"
                  :error-messages="error"
                  label="Sequence"
                  outlined
                  hint="Paste a sequence"
                  persistent-hint
                  @change="sequenceHandler"
              ></v-textarea>
            </v-flex>
            <v-flex xs12 sm4 v-if="!sequence">
              <v-autocomplete
                  v-model="selectedGenes"
                  :items="geneNames"
                  :filter="geneFilter"
                  item-text="gene"
                  item-value="gene"
                  no-data-text="Loading..."
                  :loading="genesLoading"
                  :error-messages="error"
                  label="Gene name"
                  multiple
                  chips
                  outlined
                  deletable-chips
                  hint="Select one or multiple gene names"
                  persistent-hint
                  @change="genesHandler"
              >
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-container>
        <v-flex align-self-center>
          <v-switch
              v-model="sequence"
              @change="sequenceToggle"
              color="primary"
              label="Enter sequence"
          ></v-switch>
        </v-flex>
        <v-flex align-self-center>
          <v-btn @click="searchHandler" color="primary" class="mt-2" large>Search</v-btn>
        </v-flex>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import Logo from '../components/Logo';
  import api from '../api';

  export default {
    name: 'Home',
    components: {
      Logo
    },
    data() {
      return {
        selectedSpecies: '',
        geneNames: [],
        selectedGenes: [],
        selectedSequence: '',
        sequence: false,
        genesLoading: true,
        error: null
      }
    },
    computed: {
      ...mapState([
        'species',
        'filter'
      ])
    },
    watch: {
      selectedSequence(val) {
        const regex = new RegExp(/[^ACGT]/g);
        if (val.match(regex)) {
          this.error = 'Removed invalid characters';
          setTimeout(() => this.error = null, 1500);
          this.$nextTick(() => this.selectedSequence = val.replace(regex, ''));
        }
      }
    },
    mounted() {
      this.selectedSpecies = this.filter.species;
      this.selectedGenes = this.filter.genes;
      this.sequence = this.filter.sequence;
      this.selectedSequence = this.filter.sequenceText;

      this.refreshGenes();
    },
    methods: {
      ...mapActions([
          'updateSpecies',
          'updateGenes',
          'toggleSequence',
          'updateSequence'
      ]),

      sequenceToggle() {
        this.toggleSequence(this.sequence);
      },

      sequenceHandler() {
        this.updateSequence(this.selectedSequence);
      },

      speciesHandler() {
        this.updateSpecies(this.selectedSpecies);
        this.selectedGenes = [];
        this.genesHandler();
        this.refreshGenes();
      },

      genesHandler() {
        this.updateGenes(this.selectedGenes);
      },

      searchHandler() {
        if ((!this.sequence && this.selectedGenes.length > 0) || (this.sequence && this.selectedSequence !== '')) {
          this.$router.push('result');
        } else {
          this.error = 'May not be empty';
          setTimeout(() => this.error = null, 1500);
        }
      },

      refreshGenes() {
        this.genesLoading = true;
        this.geneNames = [];
        api.getGenes(this.selectedSpecies)
          .then(res => {
            this.geneNames = res.data;
            this.genesLoading = false;
          });
      },

      geneFilter(item, queryText) {
        const t1 = item.gene.toLowerCase();
        const t2 = item.aliasGenes;
        const q = queryText.toLowerCase();

        return t1.indexOf(q) > -1 || t2.indexOf(q) > -1;
      }
    }
  }
</script>
